module.exports = __webpack_public_path__ + "static/media/VV 12.b5b8db4f.mp3";